/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsWaterHeater: {
  name: 'water-heater';
  data: string;
} = {
  name: 'water-heater',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 2a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h4v2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2v-2h2a2 2 0 0 0 2-2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2a2 2 0 0 0-2-2H5Zm12 3V4H7v8h10V5Zm2 5V6h2v4h-2ZM3 6a2 2 0 0 1 2-2v8a2 2 0 0 1-2-2V6Zm8 10v-2h2v2h-2Zm-1 2H9v2h6v-2h-5Zm4-10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></svg>`,
};
